module.exports = new __parcel__URL__("easy-estimate-home.0106ece9.png").toString();